/**
 * Product Collection Tabs Section Controller
 * Handles tab switching, responsive scroll progress bar, drag-to-scroll, and Shopify Theme Editor integration.
 */

(function () {
  'use strict';

  function initProductCollectionTabs(section) {
    if (!section) return;

    const navButtons = section.querySelectorAll('.product-collection-tabs__tab-btn:not(.product-collection-tabs__tab-link)');
    const panels = section.querySelectorAll('.product-collection-tabs__panel');

    function setActiveTab(targetId) {
      navButtons.forEach(btn => {
        const isTarget = btn.getAttribute('data-tab-target') === targetId;
        btn.classList.toggle('is-active', isTarget);
        btn.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      });

      panels.forEach(panel => {
        const isTarget = panel.id === targetId;
        panel.classList.toggle('is-active', isTarget);
        panel.style.display = isTarget ? 'block' : 'none';

        if (isTarget) {
          setupSlider(panel);
        }
      });
    }

    navButtons.forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('data-tab-target');
        if (targetId) {
          setActiveTab(targetId);
        }
      });
    });

    function setupSlider(panel) {
      const slider = panel.querySelector('[data-pct-slider]');
      const progressBar = panel.querySelector('[data-pct-progress-bar]');
      const progressTrack = panel.querySelector('.product-collection-tabs__progress-track');
      if (!slider) return;

      function updateProgress() {
        if (!progressBar || !progressTrack) return;
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        const trackWidth = progressTrack.clientWidth;

        if (maxScroll <= 5) {
          progressBar.style.width = '100%';
          progressBar.style.transform = 'translateX(0)';
          return;
        }

        const visibleRatio = Math.min(1, Math.max(0.15, slider.clientWidth / slider.scrollWidth));
        const barWidth = Math.max(40, trackWidth * visibleRatio);
        progressBar.style.width = barWidth + 'px';

        const scrollProgress = Math.min(1, Math.max(0, slider.scrollLeft / maxScroll));
        const translateX = scrollProgress * (trackWidth - barWidth);
        progressBar.style.transform = `translateX(${translateX}px)`;
      }

      slider.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress, { passive: true });

      // Mouse drag to scroll
      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        slider.style.cursor = 'grabbing';
        slider.style.userSelect = 'none';
      });

      window.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        slider.style.cursor = '';
        slider.style.removeProperty('user-select');
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1.5;
        slider.scrollLeft = scrollLeft - walk;
      });

      // Initial calculate
      setTimeout(updateProgress, 100);
    }

    // Initialize the initially active panel
    const initialPanel = section.querySelector('.product-collection-tabs__panel.is-active') || panels[0];
    if (initialPanel) {
      setupSlider(initialPanel);
    }
  }

  function initAll() {
    document.querySelectorAll('.product-collection-tabs-section').forEach(initProductCollectionTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', function (e) {
    const sec = e.target.querySelector('.product-collection-tabs-section') || (e.target.classList.contains('product-collection-tabs-section') ? e.target : null);
    if (sec) {
      initProductCollectionTabs(sec);
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    const blockId = e.detail.blockId;
    const targetPanel = document.getElementById(`PctPanel-${e.detail.sectionId}-${blockId}`);
    if (targetPanel) {
      const section = targetPanel.closest('.product-collection-tabs-section');
      if (section) {
        const btn = section.querySelector(`[data-tab-target="PctPanel-${e.detail.sectionId}-${blockId}"]`);
        if (btn) btn.click();
      }
    }
  });
})();
